var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { Subject } from 'rxjs';
import { Store } from '@ngxs/store';
export var WelcomeTourEnum;
(function (WelcomeTourEnum) {
    WelcomeTourEnum[WelcomeTourEnum["NewUser"] = 0] = "NewUser";
    WelcomeTourEnum[WelcomeTourEnum["ExistingUser"] = 1] = "ExistingUser";
    WelcomeTourEnum[WelcomeTourEnum["Group"] = 2] = "Group";
})(WelcomeTourEnum || (WelcomeTourEnum = {}));
var SlideData = /** @class */ (function () {
    function SlideData() {
    }
    return SlideData;
}());
var baseWelcomeSlides = [
    {
        title: 'Explore',
        text: 'Browse our digital library for 3D models to complement your curriculum.',
        image: '/assets/images/welcome-tour-explore.jpg'
    },
    {
        title: 'Customize',
        text: 'Use our authoring tools to create 3D views tailored to your educational goals.',
        image: '/assets/images/welcome-tour-customize.jpg'
    },
    {
        title: 'Collaborate',
        text: 'Share your saved 3D views with your team from a central Dashboard.',
        image: '/assets/images/welcome-tour-collaborate.jpg'
    },
    {
        title: 'Integrate',
        text: 'Publish your interactive 3D model and drop into your digital content.',
        image: '/assets/images/welcome-tour-integrate.jpg'
    }
];
var newUserSlides = __spread([
    {
        text: 'We make it easy to visualize the human body<br/> for your educational needs - all in interactive 3D.',
        logo: '/assets/images/biodigital-logo.svg'
    }
], baseWelcomeSlides);
var existingUserSlides = [
    {
        title: 'Introducing Human Studio',
        text: 'The first product for authoring custom interactive 3D models of anatomy, disease and treatments.',
        image: '/assets/images/studio-tour-studio.jpg'
    },
    {
        title: 'Interactive Labels',
        text: 'Quickly add anatomical labels to call out key learning objectives.',
        image: '/assets/images/studio-tour-labels.jpg'
    },
    {
        title: 'Paint',
        text: 'Customize the look and feel of your 3D model by applying different paint effects to anatomical structures.',
        image: '/assets/images/studio-tour-paint.jpg'
    },
    {
        title: 'Tour Builder',
        text: 'Tell an interactive story by stringing together different views of your 3D model.',
        image: '/assets/images/studio-tour-tour.jpg'
    },
    {
        title: 'Text Manager',
        text: 'Add or modify text from one dedicated place.',
        image: '/assets/images/studio-tour-text.jpg'
    }
];
var WelcomeTourDialogComponent = /** @class */ (function () {
    function WelcomeTourDialogComponent(store, dialogRef, data) {
        this.store = store;
        this.dialogRef = dialogRef;
        this.data = data;
        this.ngUnsubscribe = new Subject();
        this.settings = {
            userType: WelcomeTourEnum.NewUser
        };
        this.slides = [];
        this.selectedIndex = 0;
        this.settings = __assign({}, this.settings, data);
        // set data source
        var type = this.settings.userType;
        switch (type) {
            case WelcomeTourEnum.NewUser:
                this.slides = newUserSlides;
                break;
            case WelcomeTourEnum.ExistingUser:
                this.slides = existingUserSlides;
                break;
            default:
                break;
        }
    }
    Object.defineProperty(WelcomeTourDialogComponent.prototype, "isFirstSlide", {
        get: function () {
            return this.selectedIndex === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WelcomeTourDialogComponent.prototype, "isLastSlide", {
        get: function () {
            return this.selectedIndex === this.slides.length - 1;
        },
        enumerable: true,
        configurable: true
    });
    WelcomeTourDialogComponent.prototype.ngOnInit = function () {
    };
    WelcomeTourDialogComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    WelcomeTourDialogComponent.prototype.handleCloseTour = function () {
        this.close();
    };
    WelcomeTourDialogComponent.prototype.close = function () {
        // close dialog
        this.dialogRef.close();
    };
    WelcomeTourDialogComponent.prototype.handleSelectSlideClick = function (index) {
        this.selectedIndex = index;
    };
    WelcomeTourDialogComponent.prototype.handleNextClick = function () {
        this.incrementSelectedIndex(1);
    };
    WelcomeTourDialogComponent.prototype.handlePrevClick = function () {
        this.incrementSelectedIndex(-1);
    };
    WelcomeTourDialogComponent.prototype.incrementSelectedIndex = function (increment) {
        var targetIndex = this.selectedIndex + increment;
        this.selectedIndex = Math.max(0, targetIndex) % this.slides.length;
    };
    return WelcomeTourDialogComponent;
}());
export { WelcomeTourDialogComponent };
